import { render } from "./Foo.vue?vue&type=template&id=e5d4ec44"
import script from "./Foo.vue?vue&type=script&lang=js"
export * from "./Foo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__